import { message } from "antd";
import axios from "axios";

// Fetch one mockup template for mockup generator
export const fetchMockupTemplateByUUID = (uuid) => async (dispatch) => {
    await axios
        .get(`/api/mockups/fetch_mockup_template_by_uuid/${uuid}`)
        .then(async (response) => {
            dispatch({
                type: "FETCH_MOCKUP_TEMPLATE_SUCCESS",
                payload: response.data,
            });
        })
        .catch((error) => {
            message.error(error?.response?.data?.message, 5);
        });
};

// Upload design and generate mockups
export const uploadAndGenerateMockup =
    (
        mockup_uuid,
        mockup_credits,
        edited,
        uploaded_image_object,
        uploaded_image_style = ""
    ) =>
    async (dispatch) => {
        await axios
            .post(
                `/api/mockups/upload_and_mockup/${edited}/${mockup_uuid}/${mockup_credits}`,
                {
                    uploaded_image: uploaded_image_object,
                    style: uploaded_image_style,
                }
            )
            .then(async (response) => {
                dispatch({
                    type: "GENERATE_MOCKUP_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
